import { useCallback, useState } from "react"
import { Button } from "react-bootstrap"
import BusConfigSlider from "../Sliders/BusConfigSlider"
import CommSlider from "../Sliders/CommSlider"
import PowerSlider from "../Sliders/PowerSlider"
import { hasNonEmptyCloneTemplateData } from "../utils"
import { useSelector } from "react-redux"
import { BusSvg, CommSvg, PowerSvg } from "../Svgs/CatalogSvgs"
import BusSlider from "../Sliders/BusSlider"

interface CreateBusDetailsProps {
    allCatalog: any[];
    setCreateBusStage: React.Dispatch<React.SetStateAction<'first' | 'second'>>;
    setOpenConfirmationDialog: React.Dispatch<React.SetStateAction<boolean>>;
    blankTemplateData: { [key: string]: any };
}

const CreateBusDetails = ({ allCatalog, setOpenConfirmationDialog, setCreateBusStage, blankTemplateData }: CreateBusDetailsProps) => {

    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);

    const [selectedComp, setSelectedComp] = useState<string>('');

    const [busConfig, setBusConfig] = useState<{ [key: string]: boolean }>({
        isBus: true,
        isComm: false,
        isPower: false,
    })

    const [busSlider, setBusSlider] = useState({
        busSliderSet: false,
        data: {},
        type: "",
        subSystem: "",
        numUnits: 0,
    })

    const enableBusSlider = useCallback((
        comp_data: any,
        comp_type: string,
        comp_subSystem: string,
        comp_numUnits: number
    ) => {
        setBusSlider({
            busSliderSet: true,
            data: comp_data,
            type: comp_type,
            subSystem: comp_subSystem,
            numUnits: comp_numUnits,
        })
    }, []);

    const closeBusSlider = useCallback(() => {
        setSelectedComp('')
        setBusSlider({
            busSliderSet: false,
            data: {},
            type: "",
            subSystem: "",
            numUnits: 0,
        })
    }, [])

    const navigateSteps = (selectedStep: string) => {
        // findout the active step
        const activeStep = Object.keys(busConfig).find((key) => busConfig[key] === true)
        if (activeStep === selectedStep) return
        const validateStep = activeStep === 'isBus' ? ['Core', 'Payload'] : activeStep === 'isComm' ? selectedStep === 'isBus' ? ['Core', 'Payload'] : ['Comm'] : ['isBus', 'isComm'].includes(selectedStep) ? ['Core', 'Payload', 'Comm'] : ['Power']
        const validate = hasNonEmptyCloneTemplateData(CloneTemplate, validateStep);
        if (!validate) return
        closeBusSlider();
        setBusConfig(prev => {
            const newConfig: { [key: string]: boolean } = {};
            Object.keys(prev).forEach((key) => {
                newConfig[key] = key === selectedStep;
            });
            return newConfig;
        })
    }

    const navigateNextStep = () => {
        const activeStep = busConfig?.['isBus'] ? 'isBus' : busConfig?.['isComm'] ? 'isComm' : 'isPower'
        const selectedStep = activeStep === 'isBus' ? 'isComm' : activeStep === 'isComm' ? 'isPower' : 'second'
        const validateStep = activeStep === 'isBus' ? ['Core', 'Payload'] : activeStep === 'isComm' ? ['Comm'] : ['Power']
        const validate = hasNonEmptyCloneTemplateData(CloneTemplate, validateStep);
        if (!validate) return
        closeBusSlider();
        if (selectedStep === 'second') {
            setCreateBusStage("second");
        } else {
            setBusConfig(prev => {
                const newConfig: { [key: string]: boolean } = {};
                Object.keys(prev).forEach((key) => {
                    newConfig[key] = key === selectedStep;
                });
                return newConfig;
            })
        }
    }

    return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-end">
            <div className="configurator-nav top-100px z-2">
                <div className="config-menu d-flex flex-column gap-2">
                    <div
                        className={busConfig?.['isBus'] ? "config-item-link active" : "config-item-link"}
                        onClick={() => {
                            navigateSteps('isBus')
                        }}
                    >
                        <BusSvg />
                        <span>Bus</span>
                    </div>
                    <div
                        className={busConfig?.['isComm'] ? "config-item-link active" : "config-item-link"}
                        onClick={() => {
                            navigateSteps('isComm')
                        }}
                    >
                        <CommSvg />
                        <span>Comm.</span>
                    </div>
                    <div
                        className={busConfig?.['isPower'] ? "config-item-link active" : "config-item-link"}
                        onClick={() => {
                            navigateSteps('isPower');
                        }}
                    >
                        <PowerSvg />
                        <span>Power</span>
                    </div>
                </div>
            </div>
            <div className="d-flex overflow-y-auto w-95 justify-content-start">
                <div className="configurator-box w-auto position-relative">
                    {busConfig?.['isBus'] && (
                        <BusSlider
                            selectedComp={selectedComp}
                            setSelectedComp={setSelectedComp}
                            enableBusSlider={enableBusSlider}
                            blankTemplateData={blankTemplateData}
                        />

                    )}
                    {busConfig?.['isComm'] &&
                        <CommSlider
                            blankTemplateData={blankTemplateData}
                            selectedComp={selectedComp}
                            setSelectedComp={setSelectedComp}
                            enableBusSlider={enableBusSlider}
                        />
                    }
                    {busConfig?.['isPower'] &&
                        <PowerSlider
                            blankTemplateData={blankTemplateData}
                            selectedComp={selectedComp}
                            setSelectedComp={setSelectedComp}
                            enableBusSlider={enableBusSlider}
                        />
                    }
                </div>
            </div>


            <div className="navigator-btn gap-3">
                <Button
                    variant="outline-danger"
                    type="button"
                    className="d-flex align-items-center btn-outline-danger pt-1 pb-1 pe-5 ps-4 fs-14 "
                    onClick={() => {
                        setOpenConfirmationDialog(true)
                    }}
                >
                    <i className="fe fe-x me-1 fs-16"></i>
                    Close
                </Button>
                <div className="btn-group btn-grp-nav">
                    <Button
                        variant={"primary"}
                        type="button"
                        className={`d-flex align-items-center btn btn-primary
                                pt-1 pb-1 pe-5 ps-4 fs-14`}
                        onClick={navigateNextStep}
                    >
                        Next
                        <i className="fe fe-chevron-right ms-1 fs-16"></i>
                    </Button>
                </div>
            </div>
            {busSlider.busSliderSet && <BusConfigSlider allComponents={allCatalog} closeBusSlider={closeBusSlider} busSlider={busSlider} newTemplate={true} />}

        </div>
    )
}

export default CreateBusDetails;